import type HistoryDialogProperties from './HistoryDialog.properties.ts';
import { useState } from 'react';
import { useMarketComponentHistorySelectByMarketComponentId } from '../../apis/market-component-history/useMarketComponentHistorySelectByMarketComponentId.ts';
import { useMarketComponentHistorySelectByMarketId } from '../../apis/market-component-history/useMarketComponentHistorySelectByMarketId.ts';

export const useHistoryDialog = (props: HistoryDialogProperties) => {
  const [page, setPage] = useState(1);
  const marketId = props.isMarketId ? props.id.toString() : undefined;
  const marketComponentId = !props.isMarketId ? props.id.toString() : undefined;

  const marketQuery = useMarketComponentHistorySelectByMarketId(marketId, page);
  const mcQuery = useMarketComponentHistorySelectByMarketComponentId(marketComponentId, page);

  const activeQuery = props.isMarketId ? marketQuery : mcQuery;

  const histories = Array.isArray(activeQuery.data) ? activeQuery.data : [];
  const totalPage = histories[0]?.metaOutput?.totalPages ?? 1;

  const previous = () => setPage((p) => Math.max(1, p - 1));
  const next = () => setPage((p) => Math.min(totalPage, p + 1));

  return {
    loading: activeQuery.isLoading || activeQuery.isFetching,
    page,
    totalPage,
    histories,
    previous,
    next,
  };
};
